import { Component } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { MpsUserService } from '../../../../../mps/mps-auth';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  public constructor(
    public translateService: TranslateService,
    public userService: MpsUserService,
  ) {
    translateService.setDefaultLang('en');
    if (this.userService && this.userService._user && this.userService._user.getValue()) {
      const user = this.userService._user.getValue();
      if (user.lang) {
        translateService.use(user.lang);
      } else {
        translateService.use('en');
      }
    }
  }
}